import { convertDatesToISO, getHeaders } from '@/config/aux'
import { SensorExtraction } from '../models/sensorExtraction'
import { SensorExtractionStateType } from './state'
import axios from 'axios'

export interface SensorExtractionActionsType {
  getSensorExtractions(): Promise<void>
  getSensorExtractionsBySensorSettingId(sensorSettingId: string): Promise<void>
  getSensorExtractionsByType(type: string): Promise<void>
  getActiveSensorExtractions(): Promise<void>
  getOverdueSensorExtractions(): Promise<void>
  postSensorExtraction(sensorExtraction: SensorExtraction): Promise<void>
  putSensorExtraction(sensorExtraction: SensorExtraction): Promise<void>
  deleteSensorExtraction(id: string): Promise<void>
  syncSensorExtraction(id: string): Promise<void>
  toggleSensorExtractionStatus(id: string): Promise<void>
  bulkSyncSensorExtractions(ids: string[]): Promise<void>
}

export const SensorExtractionActions = {
  async getSensorExtractions(this: SensorExtractionStateType) {
    try {
      this.sensorExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorExtraction: SensorExtraction) => {
            this.sensorExtractions.push(new SensorExtraction(sensorExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorExtractions', error)
    }
  },
  async getSensorExtractionsBySensorSettingId(this: SensorExtractionStateType, sensorSettingId: string) {
    try {
      this.sensorExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/sensor-setting/${sensorSettingId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorExtraction: SensorExtraction) => {
            this.sensorExtractions.push(new SensorExtraction(sensorExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorExtractions by sensorSettingId', error)
    }
  },
  async getSensorExtractionsByType(this: SensorExtractionStateType, type: string) {
    try {
      this.sensorExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/type/${type}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorExtraction: SensorExtraction) => {
            this.sensorExtractions.push(new SensorExtraction(sensorExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorExtractions by type', error)
    }
  },
  async getActiveSensorExtractions(this: SensorExtractionStateType) {
    try {
      this.sensorExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/active`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorExtraction: SensorExtraction) => {
            this.sensorExtractions.push(new SensorExtraction(sensorExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting active SensorExtractions', error)
    }
  },
  async getOverdueSensorExtractions(this: SensorExtractionStateType) {
    try {
      this.sensorExtractions = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/overdue`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorExtraction: SensorExtraction) => {
            this.sensorExtractions.push(new SensorExtraction(sensorExtraction))
          })
        }
      })
    } catch (error) {
      console.error('Error getting overdue SensorExtractions', error)
    }
  },
  async postSensorExtraction(this: SensorExtractionStateType, sensorExtraction: SensorExtraction) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions`
      const data = convertDatesToISO(sensorExtraction.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.sensorExtractions.push(sensorExtraction)
        }
      })
    } catch (error) {
      console.error('Error posting SensorExtraction', error)
    }
  },
  async putSensorExtraction(this: SensorExtractionStateType, sensorExtraction: SensorExtraction) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions`
      const data = convertDatesToISO(sensorExtraction.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.sensorExtractions = this.sensorExtractions.map(se => (se.id === sensorExtraction.id ? sensorExtraction : se))
          }
        })
    } catch (error) {
      console.error('Error updating SensorExtraction', error)
    }
  },
  async deleteSensorExtraction(this: SensorExtractionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.sensorExtractions = this.sensorExtractions.filter(se => se.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting SensorExtraction', error)
    }
  },
  async syncSensorExtraction(this: SensorExtractionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/${id}/sync`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar lastSyncAt en el store local
          // this.getSensorExtractions()
        }
      })
    } catch (error) {
      console.error('Error syncing SensorExtraction', error)
    }
  },
  async toggleSensorExtractionStatus(this: SensorExtractionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/${id}/toggle`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar estado activo en el store local
          // this.getSensorExtractions()
        }
      })
    } catch (error) {
      console.error('Error toggling SensorExtraction status', error)
    }
  },
  async bulkSyncSensorExtractions(this: SensorExtractionStateType, ids: string[]) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-extractions/bulk-sync`
      const data = { ids }

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar todas las extracciones sincronizadas
          // this.getSensorExtractions()
        }
      })
    } catch (error) {
      console.error('Error bulk syncing SensorExtractions', error)
    }
  },
}
